import React, { useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import products from "../components/products.js";
import "./ProductDetail.css";

import NavBar from "../components/Navbar.jsx";

const ProductDetail = () => {
  const { id } = useParams();
  const product = useMemo(
    () => products.find((p) => String(p.id) === String(id)),
    [id]
  );

  const [active, setActive] = useState(0);

  if (!product) return <div className="pd-container">Product not found</div>;

  // product.images[0] → main image
  // product.images[1..] → thumbnails
  const images = product.images || [];
  const thumbnails = images.slice(1); // skip main image

  const youMayAlsoLike = products.filter((p) => String(p.id) !== String(id)).slice(0, 4);

  return (
    <>
      <NavBar textColor="#000" />
      <div className="pd-page">
        <div className="pd-container">
          <div className="pd-grid">
            {/* Left thumbnails */}
            <div className="pd-thumbs-vertical">
              {thumbnails.map((src, i) => (
                <button
                  key={i + 1}
                  className={`pd-thumb-vertical ${i + 1 === active ? "active" : ""}`}
                  onClick={() => setActive(i + 1)}
                  aria-label={`Thumbnail ${i + 2}`}
                >
                  <img src={src} alt={`${product.title} thumbnail ${i + 2}`} />
                </button>
              ))}
            </div>

            {/* Main image */}
            <div className="pd-main" aria-label="Main product image">
              {images[active] && (
                <img
                  src={images[active]}
                  alt={`${product.title} image ${active + 1}`}
                  className="pd-main-img"
                />
              )}
            </div>

            {/* Product Info — same width & height as .pd-main on desktop */}
            <aside className="pd-info">
              <h1 className="pd-title">{product.title}</h1>
              
              {/* <div className="pd-price-row">
                <span className="pd-price">
                  {product.price ? `$${product.price}` : ""}
                </span>
              </div> */}

              <div className="pd-details">
                <section className="pd-detail-block">
                  <h3 className="pd-detail-heading">Description</h3>
                  <p className="pd-detail-text">{product.description}</p>
                </section>

                {product.highlightImage && (
                  <div className="pd-highlights">
                    <img
                      src={product.highlightImage}
                      alt="Product Highlights"
                      className="pd-highlights-img"
                    />
                  </div>
                )}
              </div>
            </aside>
          </div>

          {/* Related products */}
          <section className="pd-related">
            <h2 className="pd-section-title">You may also like</h2>
            <hr className="pd-hr pd-hr--soft" />
            <div className="pd-related-grid">
              {youMayAlsoLike.map((p) => (
                <Link key={p.id} to={`/product/${p.id}`} className="pd-rel-card">
                  <div className="pd-rel-img">
                    {p.images?.[0] && <img src={p.images[0]} alt={p.title} />}
                  </div>
                  <h4>{p.title}</h4>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ProductDetail;
